"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _button = require("@design/ui/button");
var _dialog = require("@design/ui/dialog");
var _label = require("@design/ui/label");
var _select = require("@design/ui/select");
var _spinner = require("@design/ui/spinner");
var _textarea = require("@design/ui/textarea");
var _ContentControlDifferenceSummary = _interopRequireDefault(require("./ContentControlDifferenceSummary"));
var _sentryReporter = require("../../utils/sentry-reporter");
var _toast = require("../../utils/toast");
var _log = require("../../utils/wopi/log");
var _wopiSession = require("../../utils/wopi/wopi-session");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t3 in e) "default" !== _t3 && {}.hasOwnProperty.call(e, _t3) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t3)) && (i.get || i.set) ? o(f, _t3, i) : f[_t3] = e[_t3]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var SAVE_FOOTNOTE = "After you save changes, edits by all users are saved as a new version and the document cannot be edited.";
var SaveNewVersionDialog = function SaveNewVersionDialog(_ref) {
  var open = _ref.open,
    onOpenChange = _ref.onOpenChange,
    versionLabelOptions = _ref.versionLabelOptions,
    isVersionLabelMandatory = _ref.isVersionLabelMandatory;
  var _useState = (0, _react.useState)(""),
    _useState2 = _slicedToArray(_useState, 2),
    versionLabel = _useState2[0],
    setVersionLabel = _useState2[1];
  var _useState3 = (0, _react.useState)(""),
    _useState4 = _slicedToArray(_useState3, 2),
    note = _useState4[0],
    setNote = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isValidating = _useState6[0],
    setIsValidating = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isSaving = _useState8[0],
    setIsSaving = _useState8[1];
  var _useState9 = (0, _react.useState)(null),
    _useState0 = _slicedToArray(_useState9, 2),
    changeSummary = _useState0[0],
    setChangeSummary = _useState0[1];
  var _useState1 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState1, 2),
    hasPendingSave = _useState10[0],
    setHasPendingSave = _useState10[1];
  var fieldId = (0, _react.useId)();
  var validationStartedRef = (0, _react.useRef)(false);
  var hasVersionLabels = versionLabelOptions.length > 0;
  var isVersionLabelSatisfied = !isVersionLabelMandatory || !hasVersionLabels || versionLabel !== "";
  var canSave = !isValidating && !isSaving && isVersionLabelSatisfied;
  function completeSave() {
    _wopiSession.wopiSession.postReloadDocument();
    (0, _toast.toastSuccess)("Document saved as a new version.");
    onOpenChange(false);
  }
  function reportSaveFailure(error) {
    (0, _log.wlog)("save dialog: save failed → error toast", error);
    (0, _sentryReporter.reportError)(error, {
      extra: {
        component: "SaveNewVersionDialog",
        action: "save_new_version"
      }
    });
    (0, _toast.toastError)("Failed to save the document. Please try again.");
  }
  (0, _react.useEffect)(function () {
    if (!open) {
      validationStartedRef.current = false;
      return;
    }
    if (validationStartedRef.current) return;
    validationStartedRef.current = true;
    setVersionLabel("");
    setNote("");
    setChangeSummary(null);
    setHasPendingSave(false);
    function runValidationPass() {
      return _runValidationPass.apply(this, arguments);
    }
    function _runValidationPass() {
      _runValidationPass = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var result, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              (0, _log.wlog)("save dialog: opened → running validation pass");
              setIsValidating(true);
              _context.p = 1;
              _context.n = 2;
              return _wopiSession.wopiSession.beginSaveNewVersion({});
            case 2:
              result = _context.v;
              if (!(result.committed === false)) {
                _context.n = 3;
                break;
              }
              (0, _log.wlog)("save dialog: validation pass complete", result.changeSummary);
              setHasPendingSave(true);
              setChangeSummary(result.changeSummary);
              return _context.a(2);
            case 3:
              (0, _log.wlog)("save dialog: committed on the validation pass → note and label go with a follow-up save");
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              reportSaveFailure(_t);
              onOpenChange(false);
            case 5:
              _context.p = 5;
              setIsValidating(false);
              return _context.f(5);
            case 6:
              return _context.a(2);
          }
        }, _callee, null, [[1, 4, 5, 6]]);
      }));
      return _runValidationPass.apply(this, arguments);
    }
    void runValidationPass();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  function handleSaveChanges() {
    return _handleSaveChanges.apply(this, arguments);
  }
  function _handleSaveChanges() {
    _handleSaveChanges = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            (0, _log.wlog)("save dialog: confirm save", {
              hasPendingSave: hasPendingSave
            });
            setIsSaving(true);
            _context2.p = 1;
            if (!hasPendingSave) {
              _context2.n = 3;
              break;
            }
            _context2.n = 2;
            return _wopiSession.wopiSession.confirmSaveNewVersion({
              note: note,
              versionLabel: versionLabel
            });
          case 2:
            _context2.n = 4;
            break;
          case 3:
            _context2.n = 4;
            return _wopiSession.wopiSession.saveWithDocument({
              answer: true,
              note: note || undefined,
              versionLabel: versionLabel || undefined
            });
          case 4:
            completeSave();
            _context2.n = 6;
            break;
          case 5:
            _context2.p = 5;
            _t2 = _context2.v;
            reportSaveFailure(_t2);
            onOpenChange(false);
          case 6:
            _context2.p = 6;
            setIsSaving(false);
            return _context2.f(6);
          case 7:
            return _context2.a(2);
        }
      }, _callee2, null, [[1, 5, 6, 7]]);
    }));
    return _handleSaveChanges.apply(this, arguments);
  }
  function handleCancel() {
    return _handleCancel.apply(this, arguments);
  }
  function _handleCancel() {
    _handleCancel = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            (0, _log.wlog)("save dialog: cancelled");
            onOpenChange(false);
            _context3.n = 1;
            return _wopiSession.wopiSession.cancelSaveNewVersion();
          case 1:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return _handleCancel.apply(this, arguments);
  }
  function submitSave(event) {
    event.preventDefault();
    if (canSave) void handleSaveChanges();
  }
  function handleOpenChange(nextOpen) {
    if (nextOpen) {
      onOpenChange(true);
      return;
    }
    if (isValidating || isSaving) return;
    void handleCancel();
  }
  function renderChangeSummarySection() {
    if (isValidating) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex items-center gap-2 text-sm text-muted-foreground",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_spinner.Spinner, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: "Loading changes..."
        })]
      });
    }
    if (changeSummary) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContentControlDifferenceSummary.default, {
      changeSummary: changeSummary
    });
    return null;
  }
  var versionLabelField = hasVersionLabels ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col gap-2",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_label.Label, {
      htmlFor: "".concat(fieldId, "-version-label"),
      children: ["Version label", isVersionLabelMandatory ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "text-destructive",
        children: "*"
      }) : null]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_select.Select, {
      value: versionLabel,
      onValueChange: setVersionLabel,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectTrigger, {
        id: "".concat(fieldId, "-version-label"),
        className: "w-full",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectValue, {
          placeholder: "Select"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectContent, {
        children: versionLabelOptions.map(function (option) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectItem, {
            value: option.value,
            children: option.label
          }, option.value);
        })
      })]
    })]
  }) : null;
  var noteField = /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col gap-2",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_label.Label, {
      htmlFor: "".concat(fieldId, "-note"),
      children: "Note"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_textarea.Textarea, {
      id: "".concat(fieldId, "-note"),
      className: "min-h-30",
      placeholder: "Add note...",
      value: note,
      onChange: function onChange(event) {
        return setNote(event.target.value);
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "text-sm text-muted-foreground",
      children: SAVE_FOOTNOTE
    })]
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_dialog.Dialog, {
    open: open,
    onOpenChange: handleOpenChange,
    "data-sentry-element": "Dialog",
    "data-sentry-component": "SaveNewVersionDialog",
    "data-sentry-source-file": "SaveNewVersionDialog.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dialog.DialogContent, {
      "aria-describedby": undefined,
      "data-sentry-element": "DialogContent",
      "data-sentry-source-file": "SaveNewVersionDialog.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dialog.DialogHeader, {
        "data-sentry-element": "DialogHeader",
        "data-sentry-source-file": "SaveNewVersionDialog.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dialog.DialogTitle, {
          "data-sentry-element": "DialogTitle",
          "data-sentry-source-file": "SaveNewVersionDialog.tsx",
          children: "Save new version"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("form", {
        onSubmit: submitSave,
        className: "contents",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "flex flex-col gap-4",
          children: [renderChangeSummarySection(), versionLabelField, noteField]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dialog.DialogFooter, {
          "data-sentry-element": "DialogFooter",
          "data-sentry-source-file": "SaveNewVersionDialog.tsx",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
            type: "button",
            variant: "outline",
            onClick: handleCancel,
            disabled: isValidating || isSaving,
            "data-sentry-element": "Button",
            "data-sentry-source-file": "SaveNewVersionDialog.tsx",
            children: "Cancel"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
            type: "submit",
            disabled: !canSave,
            "data-sentry-element": "Button",
            "data-sentry-source-file": "SaveNewVersionDialog.tsx",
            children: isSaving ? "Saving..." : "Save changes"
          })]
        })]
      })]
    })
  });
};
var _default = exports.default = SaveNewVersionDialog;